import React from 'react'
import useContractStakeBalance from '../../../hooks/useContractStakeBalance'
import ContractStatisticWidget from '../ContractStatisticWidget'

export default function TotalStakedAmount() {
  const { totalStakedAmount, isLoading: totalStakedAmountLoading } = useContractStakeBalance()

  return (
    <ContractStatisticWidget
      isLoading={totalStakedAmountLoading}
      title="Total Staked"
      value={totalStakedAmount}
      decimals={3}
      thousandSeparator={true}
      suffix=" BNB"
    />
  )
}
